/**
 * Convert hex color to RGB values
 */
export const hexToRgb = (hex: string): { r: number; g: number; b: number } => {
  const normalizedHex = hex.trim().replace(/^#/, "");

  // Support 3/4-digit shorthand (#rgb / #rgba) and 6/8-digit formats.
  // Alpha channels are ignored because this utility returns only RGB.
  let sixDigitHex = normalizedHex;
  if (/^[a-f\d]{3}$/i.test(normalizedHex) || /^[a-f\d]{4}$/i.test(normalizedHex)) {
    const [r, g, b] = normalizedHex;
    if (!r || !g || !b) {
      throw new Error(`Invalid hex color: ${hex}`);
    }
    sixDigitHex = `${r}${r}${g}${g}${b}${b}`;
  } else if (/^[a-f\d]{8}$/i.test(normalizedHex)) {
    sixDigitHex = normalizedHex.slice(0, 6);
  } else if (!/^[a-f\d]{6}$/i.test(normalizedHex)) {
    throw new Error(`Invalid hex color: ${hex}`);
  }

  const result = /^([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(sixDigitHex);
  if (!result || !result[1] || !result[2] || !result[3]) {
    throw new Error(`Invalid hex color: ${hex}`);
  }
  return {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16),
  };
};

/**
 * Convert hex color to rgba string
 */
export const hexToRgba = (hex: string, alpha: number): string => {
  const { r, g, b } = hexToRgb(hex);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};
